import './style/main.css'
import * as THREE from 'three'
import * as dat from 'dat.gui'
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls"
import vertex from './shaders/vertex.glsl'
import fragment from './shaders/fragment.glsl'

//Gui
const gui = new dat.GUI()

/**
 * Sizes
 */
const sizes = {}
sizes.width = window.innerWidth
sizes.height = window.innerHeight

window.addEventListener('resize', () =>
{
    // Save sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio,2))
})

/**
 * Environnements
 */
// Scene
const scene = new THREE.Scene()

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 3
scene.add(camera)

// Test
const geometry = new THREE.PlaneBufferGeometry(2,2,32,32)

const count = geometry.attributes.position.count
console.log(count)

const randoms = new Float32Array(count)
for(let i = 0; i < count; i++){
    randoms[i] = Math.random()
}
geometry.setAttribute('aRandom', new THREE.BufferAttribute(randoms, 1))
console.log(geometry)

const material = new THREE.RawShaderMaterial({
    vertexShader: vertex,
    fragmentShader: fragment,
    side: THREE.DoubleSide,
    wireframe: false,
    transparent: true
})

const mesh = new THREE.Mesh(geometry, material)
// mesh.position.y = 1

scene.add(mesh)


// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: document.querySelector('.webgl')
})
renderer.setPixelRatio(Math.min(window.devicePixelRatio,2))
renderer.setSize(sizes.width, sizes.height)


//Controls
const control = new OrbitControls(camera, document.querySelector('.webgl'))
control.enableDamping = true
control.autoRotate = false
control.update()


/**
 * Loop
 */



const loop = () =>
{
    // Update
    control.update()


    // Render
    renderer.render(scene, camera)

    // Keep looping
    window.requestAnimationFrame(loop)
}
loop()